"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const school_services_1 = require("./school.services");
/**
 * Format user address parameters
 * @param address - profile address parameter
 */
const formatUserAddress = (address) => {
    if (address && address.postalCode) {
        return { postalCode: address.postalCode };
    }
    return;
};
/**
 * Format user situation for spa
 * @param schoolApiEndpoint - school api endpoint url
 * @param situation - profile situation parameter
 */
const formatSituation = (schoolApiEndpoint, situation) => __awaiter(void 0, void 0, void 0, function* () {
    if (!situation) {
        return {
            status: undefined
        };
    }
    const { school, specialities, sectors } = situation, others = __rest(situation, ["school", "specialities", "sectors"]);
    const schools = {};
    if (school) {
        const response = yield fetch(`${schoolApiEndpoint}/${school}`);
        if (response.ok) {
            const schoolData = (yield response.json());
            schools[schoolData.schoolType.toLowerCase()] = school_services_1.formatSchool(schoolData);
        }
    }
    return Object.assign(Object.assign({ sector: sectors, speciality: specialities }, others), schools);
});
/**
 * Format user for spa
 * @param schoolApiEndpoint - school api endpoint url
 * @param profileInfo - Profil info from api
 */
const formatUserForSpa = (schoolApiEndpoint, _a) => __awaiter(void 0, void 0, void 0, function* () {
    var { address, newsletters, situation } = _a, userInfo = __rest(_a, ["address", "newsletters", "situation"]);
    return (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, userInfo), formatUserAddress(address)), { postalCode: address ? address.postalCode : undefined }), (yield formatSituation(schoolApiEndpoint, situation))), { newsletters: Object.keys(newsletters)
            .filter((name) => newsletters[name])
            .map(name => name) }));
});
/**
 * Get user information
 * @param userApiEndPoint - user api endpoint url
 * @param schoolApiEndPoint - school api endpoint url
 * @param userProfilVersion - user profile situation version
 * @param fetchWithCredentials - fetch credentials method
 */
exports.getUserInfo = (userApiEndPoint, schoolApiEndPoint, userProfilVersion, fetchWithCredentials) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield fetchWithCredentials(`${userApiEndPoint}/users/me`, {
            headers: {
                'X-DigiSchool-Situation-Version': userProfilVersion,
                Accept: 'application/json'
            }
        });
        if (result.ok) {
            return yield formatUserForSpa(schoolApiEndPoint, yield result.json());
        }
        throw Error('Impossible de récupérer le informations de votre profil.');
    }
    catch (error) {
        throw Error('Impossible de récupérer le informations de votre profil.');
    }
});
//# sourceMappingURL=user.services.js.map